import React from 'react'
import simg from '../../images/mission-shape.png'

const MissionVission = (props) => {
    return (
        <section className="wpo-mission-vission-section section-padding">
            <div className="container">
                <div className="row align-items-stretch">

                    {/* MİSYON */}
                    <div className="col-lg-6 col-md-12 col-12 d-flex">
                        <div className="wpo-mission-item d-flex flex-column justify-content-between h-100 w-100">
                            <div className="wpo-mission-text">
                                <h2>Misyonumuz</h2>
                                <p>
                                    Soğutma sistemleri, iç mimarlık & proje uygulama ve iş makineleri alanlarında; kalite standartlarından ödün vermeden, güvenilir, sürdürülebilir ve yenilikçi çözümler sunmak.
                                    <br /><br />
                                    Müşteri ihtiyaçlarını doğru analiz ederek; enerji verimliliği yüksek, ekonomik ve uzun ömürlü projeler üretmek, her çalışmamızda zamanında teslim ve maksimum memnuniyet sağlamak temel misyonumuzdur.
                                </p>
                                <h5>
                                    Teknik uzmanlığımız ve çözüm odaklı yaklaşımımızla sektörümüze değer katmayı ve güçlü, uzun vadeli iş ortaklıkları kurmayı hedefliyoruz.
                                </h5>
                            </div>
                            <div className="shape-1"></div>
                            <div className="shape-2">
                                <img src={simg} alt="shape" />
                            </div>
                        </div>
                    </div>

                    {/* VİZYON */}
                    <div className="col-lg-6 col-md-12 col-12 d-flex">
                        <div className="wpo-vission-item d-flex flex-column justify-content-between h-100 w-100">
                            <div className="wpo-vission-text">
                                <h2>Vizyonumuz</h2>
                                <h5>
                                    Faaliyet gösterdiğimiz tüm alanlarda teknolojiyi yakından takip eden, kalite ve güven denildiğinde ilk akla gelen, referans gösterilen bir marka olmak.
                                </h5>
                                <p>
                                    Yenilikçi uygulamalarımız, profesyonel hizmet anlayışımız ve güçlü iş birliklerimizle ulusal ve uluslararası ölçekte tercih edilen, sürdürülebilir büyüme sağlayan lider bir firma konumuna ulaşmak.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default MissionVission